module.exports = __webpack_public_path__ + "slide4-steps-ie11.17f0212ac2f7109aa38c00aad85038d2.hashedasset.svg";